/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Current_Pain_QuestionInputs */

const en_us2_onboarding_current_pain_question = /** @type {(inputs: Onboarding_Current_Pain_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you feel pain anywhere right now?`)
};

const pt_br2_onboarding_current_pain_question = /** @type {(inputs: Onboarding_Current_Pain_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você sente dor em algum lugar neste momento?`)
};

const es_419_onboarding_current_pain_question = /** @type {(inputs: Onboarding_Current_Pain_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Sientes dolor en algún lugar en este momento?`)
};

const pt_pt2_onboarding_current_pain_question = /** @type {(inputs: Onboarding_Current_Pain_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sentes dor em algum sítio neste momento?`)
};

const fr_fr2_onboarding_current_pain_question = /** @type {(inputs: Onboarding_Current_Pain_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As-tu mal quelque part en ce moment ?`)
};

const de_de2_onboarding_current_pain_question = /** @type {(inputs: Onboarding_Current_Pain_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hast du gerade irgendwo Schmerzen?`)
};

const it_it2_onboarding_current_pain_question = /** @type {(inputs: Onboarding_Current_Pain_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senti dolore da qualche parte in questo momento?`)
};

/**
* | output |
* | --- |
* | "Do you feel pain anywhere right now?" |
*
* @param {Onboarding_Current_Pain_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_current_pain_question = /** @type {((inputs?: Onboarding_Current_Pain_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Current_Pain_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_current_pain_question(inputs)
	if (locale === "es-419") return es_419_onboarding_current_pain_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_current_pain_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_current_pain_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_current_pain_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_current_pain_question(inputs)
	return en_us2_onboarding_current_pain_question(inputs)
});
export { onboarding_current_pain_question as "onboarding.current_pain.question" }